import PriceClassManagmentTabs from '../screens/PriceClassManagmentTabs'
import { ROLE, RouteWithAccessType } from './types'

const priceClassRoleManagement: RouteWithAccessType[] = [
  {
    route: '/price-class-managment/:page',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.TENANT,
      ROLE.ACCOMMODATION
    ],
    rolesListWithWriteAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.TENANT,
      ROLE.ACCOMMODATION
    ],
    requiredFeatures: ['priceclass.view'],
    component: <PriceClassManagmentTabs />,
    tabs: [
      {
        params: { page: 'price-class' },
        rolesListWithReadAccess: [ROLE.ADMIN],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['priceclass.view']
      },
      {
        params: { page: 'subscribe' },
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.TENANT,
          ROLE.ACCOMMODATION
        ],
        rolesListWithWriteAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.TENANT,
          ROLE.ACCOMMODATION
        ],
        requiredFeatures: ['priceclass.subscribe']
      },
      {
        params: { page: 'distributions' },
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.TENANT,
          ROLE.ACCOMMODATION
        ],
        rolesListWithWriteAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.TENANT,
          ROLE.ACCOMMODATION
        ],
        requiredFeatures: ['priceclass.distribution.manage']
      },
      {
        params: { page: 'exchange-rates' },
        rolesListWithReadAccess: [ROLE.ADMIN],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['priceclass.exchange.rate.view']
      }
    ]
  }
]

export default priceClassRoleManagement
